<template>
  <div class="pa-ovl" role="dialog" aria-modal="true" aria-labelledby="pa-booster-confirm-title" @click.self="$emit('close')">
    <!-- design pa-app.jsx Modal: round icon, title, muted body, optional price rows / textarea, Cancel + orange confirm -->
    <div class="pa-cmodal">
      <div class="pa-cmodal__icon"><i class="material-icons" aria-hidden="true">{{ icon }}</i></div>
      <h3 id="pa-booster-confirm-title" class="pa-cmodal__title">{{ title }}</h3>
      <p v-if="body" class="pa-cmodal__body">{{ body }}</p>
      <div v-if="lines.length" class="pa-cmodal__rows">
        <div v-for="(line, i) in lines" :key="i" class="pa-cmodal__row">
          <span>{{ line[0] }}</span><b>${{ money(line[1]) }}</b>
        </div>
      </div>
      <template v-if="reasonLabel">
        <div class="pa-cmodal__label">{{ reasonLabel }}</div>
        <textarea
          ref="reason"
          v-model="reason"
          class="pa-cmodal__text"
          rows="3"
          maxlength="2000"
          :placeholder="reasonPlaceholder"
        ></textarea>
        <p v-if="showError" class="pa-err pa-cmodal__err">Please add a short reason.</p>
      </template>
      <div class="pa-cmodal__acts">
        <button type="button" class="pa-btn pa-btn--out" :disabled="busy" @click="$emit('close')">Cancel</button>
        <button
          type="button"
          class="pa-btn pa-btn--orange"
          :disabled="busy || (reasonRequired && !reason.trim())"
          @click="submit"
        >{{ confirmLabel }}</button>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Generic booster confirmation (purchase, send invoice, mark paid, cancel invoice, cancel & refund,
 * mark in delivery) in the design's modal: icon, title, body, optional price lines and an optional
 * reason textarea. Emits `confirm` with { reason }.
 */
export default {
  name: 'PopAuthorityBoosterConfirmModal',
  props: {
    /** Material icon name (design: bolt for a purchase, receipt_long for an invoice) */
    icon: { type: String, default: 'bolt' },
    title: { type: String, required: true },
    body: { type: String, default: '' },
    /** [[label, amountInDollars], ...] */
    lines: { type: Array, default: () => [] },
    confirmLabel: { type: String, required: true },
    /** '' hides the textarea */
    reasonLabel: { type: String, default: '' },
    reasonPlaceholder: { type: String, default: '' },
    reasonRequired: { type: Boolean, default: false },
    busy: { type: Boolean, default: false },
  },
  data () {
    return {
      reason: '',
      showError: false,
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$refs.reason) this.$refs.reason.focus()
    })
  },
  methods: {
    money (v) {
      const n = Number(v) || 0
      return n.toLocaleString('en-US', { maximumFractionDigits: 0 })
    },
    submit () {
      const reason = (this.reason || '').trim()
      if (this.reasonRequired && !reason) {
        this.showError = true
        return
      }
      this.$emit('confirm', { reason })
    },
  },
}
</script>

<style lang="scss" scoped>
@import './setup/setup.scss';
@import './setup/designModal.scss';
</style>
